import {CheckCircleOutlined, UploadOutlined} from '@ant-design/icons';
import {Row, Upload, UploadFile} from 'antd';
import {RcFile} from 'antd/lib/upload/interface';
import React, {CSSProperties, useCallback, useState} from 'react';
import {FormyMode} from '../../../src/Formy';
import {File} from '../../../src/models/interfaces';
import {useApis} from '../apis/ApisContext';
import {FileAttachment} from '../components/FileAttachment';

const flexDirectionColumnAlignStart: CSSProperties = {flexDirection: 'column', alignItems: 'flex-start'};
const marginTop10 = {marginTop: '10px'};

export const AttachmentsList: React.FC<{
  existingFiles: File[];
  onUpload: (file: RcFile) => Promise<null | File>;
  mode: FormyMode;
  accept: string;
}> = ({existingFiles, onUpload, mode, accept}) => {
  const {t} = useApis();
  const [uploadedFiles, setUploadedFiles] = useState<UploadFile[]>([]);
  const handleUpload = useCallback(
    async (file: RcFile) => {
      const uploadedFile = await onUpload(file);
      if (uploadedFile) {
        setUploadedFiles(prevState => [
          ...prevState,
          {
            uid: file.uid,
            name: uploadedFile.name,
            url: uploadedFile.uri,
            originFileObj: file,
          },
        ]);
      }
    },
    [onUpload, setUploadedFiles],
  );
  return (
    <>
      {<h3>{t('Attachments')}</h3>}
      <Row gutter={16} style={flexDirectionColumnAlignStart}>
        {existingFiles.map((file, index) => (
          <FileAttachment key={`attachment-${index}`} file={file} />
        ))}
      </Row>
      {mode !== 'view' && (
        <Row style={marginTop10}>
          <Upload
            fileList={uploadedFiles}
            multiple={false}
            accept={accept}
            // Empty custom requests is used to prevent the default HTTP POST request to current URL.
            customRequest={() => {}}
            itemRender={(_, file) => {
              return (
                <div style={marginTop10}>
                  <CheckCircleOutlined /> {file.name}
                </div>
              );
            }}
            // We use beforeUpload handler instead of customRequest like in other usages across the codebase,
            // because the argument for it is always RcFile whereas with customRequest it can also be a Blob or
            // string, which creates some ambiguities on how to handle it.
            beforeUpload={handleUpload}>
            <button className="formy-input">
              <UploadOutlined /> {t('ClickUpload')}
            </button>
          </Upload>
        </Row>
      )}
    </>
  );
};
